<main class="auth-layout">
    <slot></slot>
</main>